export default class AddWallCommand {
  constructor(side) {
    this.side = side;
  }

  execute() {
    this.side?.parent?.parent?.toggleWall(this.side, true);
  }

  undo() {
    this.side?.parent?.parent?.toggleWall(this.side, false);
  }
}
